export const OtherMenu9 = () => {
  return (
    <span>
      <svg
        className="base"
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
      >
        <path
          opacity="0.3"
          d="M15.5 13H11.0556M20.9877 7C21 7.57703 21 8.23647 21 9C21 11.8003 21 13.2004 20.3945 14.27C19.8619 15.2108 19.012 15.9757 17.9666 16.455C16.7782 17 15.2225 17 12.1111 17H9.88889C6.77749 17 5.22178 17 4.03339 16.455C2.98804 15.9757 2.13815 15.2108 1.60552 14.27C1 13.2004 1 11.8003 1 9C1 8.23647 1 7.57703 1.01227 7M20.9877 7C20.955 5.46078 20.8349 4.50797 20.3945 3.73005C19.8619 2.78924 19.012 2.02433 17.9666 1.54497C16.7782 1 15.2225 1 12.1111 1H9.88889C6.77749 1 5.22178 1 4.03339 1.54497C2.98804 2.02433 2.13815 2.78924 1.60552 3.73005C1.1651 4.50797 1.04502 5.46078 1.01227 7M20.9877 7H1.01227"
          stroke="#1A1A1A"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>

      <svg
        className="active-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
      >
        <path
          d="M12.0993 0.0621339C13.5589 0.0621292 14.7032 0.0621255 15.6229 0.134244C16.5594 0.207681 17.3331 0.359697 18.0334 0.702148C19.1846 1.26512 20.1206 2.16343 20.7072 3.26833C21.135 4.07429 21.2828 4.99703 21.3383 6.18948H0.660688C0.716205 4.99703 0.863975 4.07429 1.29186 3.26833C1.87844 2.16343 2.81442 1.26512 3.96565 0.702148C4.66594 0.359697 5.43962 0.207681 6.37614 0.134244C7.29585 0.0621255 8.44017 0.0621292 9.89975 0.0621339H12.0993Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.627419 7.72132C0.625 8.11354 0.625 8.53622 0.625 8.99194V9.03212C0.624995 10.433 0.624991 11.5312 0.700135 12.4139C0.776651 13.3127 0.935042 14.0553 1.29186 14.7274C1.87844 15.8323 2.81442 16.7306 3.96565 17.2936C4.66594 17.636 5.43962 17.788 6.37614 17.8615C7.2958 17.9336 8.44005 17.9336 9.89952 17.9336H12.0993C13.5588 17.9336 14.7032 17.9336 15.6229 17.8615C16.5594 17.788 17.3331 17.636 18.0334 17.2936C19.1846 16.7306 20.1206 15.8323 20.7072 14.7274C21.064 14.0553 21.2224 13.3127 21.2989 12.4139C21.374 11.5313 21.374 10.4331 21.374 9.03234V8.99193C21.374 8.53622 21.374 8.11354 21.3716 7.72132H0.627419ZM10.5844 13.2543C10.5844 12.8313 10.9417 12.4884 11.3825 12.4884H15.6387C16.0794 12.4884 16.4367 12.8313 16.4367 13.2543C16.4367 13.6773 16.0794 14.0202 15.6387 14.0202H11.3825C10.9417 14.0202 10.5844 13.6773 10.5844 13.2543Z"
          fill="white"
        />
      </svg>
    </span>
  );
};
